<template>
  <div :style="
    'padding:' + options.data.pageCss.page_css_padding + 
    ';margin:' + options.data.pageCss.page_css_margin + 
    ';border-radius:' + options.data.pageCss.page_css_radius + 
    'px;background-color:' + options.data.pageCss.textBgc+';'+options.data.pageCss.myCss" class="article">
    <div @click="loadImg" id="img" class="article_html" v-html="options.data.desc||'请在右侧编辑文本'"></div>
    <slot></slot>
  </div>
</template>

<script>
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Article",
  props: ["index"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["okForm"]),
    ...mapGetters(["workPlace"]),
    options() {
      return this.okForm[this.index]
        ? this.okForm[this.index].options
        : { data: this.workPlace.articleBox.data };
    },
  },
  mounted() {
    this.loadImg();
  },
  methods: {
    loadImg() {
      console.log(4567);
      this.$nextTick(() => {
        const ViewerDom = document.getElementById("img");
        const viewer = new Viewer(ViewerDom, {
          url: "src",
          navbar: false,
          toolbar: false,
          zIndex: 99999,
          fullscreen: false,
          tooltip: false,
          scalable: false,
          rotatable: false,
          title: function (image) {
            // return image.alt + ' (' + (this.index + 1) + '/' + this.length + ')';
            return "";
          },
        });
      });
    },
  }
};
</script>

<style lang="less" scoped>
.article {
  max-width: 100%;
  padding: 2px;
  min-height: 100px;
  background-color: #fff;
}
.article_html {
  width: 100%;
  overflow: auto;
}
:deep(img) {
  max-width: 100% !important;
  height: unset;
}
</style>